const home = {
  "home.get.the.app.title": "Be Your Best Apps",
  "home.subscription.success.title": "Gracias por registrarte",
  "home.subscription.success.description": "Es genial tenerte a bordo. Te espera un viaje emocionante.",
  "home.account.setup.blocker.description": "Por favor espera mientras terminamos de configurar tu cuenta y autorizamos tu acceso.",
  "home.get.vr.title": "Descarga la app VR",
  "home.get.vr.meta": "App para Meta Quest",
  "home.get.mobile.title": "Descarga la app móvil",
  "home.get.mobile.android": "App para Android",
  "home.get.mobile.ios": "App para iOS",
  "home.profile.setup.continue": "Completar perfil",
};

export const portalHome = {
  ...home,
};
